import { React, PropTypes } from 'imports';
import { addEvent, removeEvent } from 'utils';
import './DragAndDropSortableList.less';

class Draggable extends React.PureComponent {

    static get propTypes() {
        return {
            sortValue: PropTypes.number.isRequired,
            entityID: PropTypes.number.isRequired,
            disabled: PropTypes.bool,
            className: PropTypes.string
        }
    }

    render() {
        throw new Error('Draggable component is not used for rendering.');
    }
}

export default class DragAndDropSortableList extends React.Component {

    static get propTypes() {
        return {
            children: PropTypes.oneOfType([
                PropTypes.arrayOf(PropTypes.instanceOf(Draggable)),
                PropTypes.node
            ]),
            className: PropTypes.string,
            onChange: PropTypes.func.isRequired
        }
    }

    static get Draggable() {
        return Draggable;
    }

    state = {
        isDragActive: false,
        dragStartY: null,
        currentlyDraggedItemID: null,
        currentlyDraggedElementHeight: 0,
        dragDeltaY: 0
    }

    componentWillUnmount() {
        this._clearEventListeners();
    }

    _onDragStart = (itemEntityID, e) => {
        this.setState({
            isDragActive: true,
            dragStartY: e.clientY,
            currentlyDraggedItemID: itemEntityID,
            currentlyDraggedElementHeight: this.refs[itemEntityID].getBoundingClientRect().height,
            dragDeltaY: 0,
        });

        addEvent(document, 'mouseup', this._onDragMouseUp);
        addEvent(document, 'keydown', this._onDragKeyDown);
        addEvent(document, 'mousemove', this._onDragMouseMove);

        // e.stopPropagation();
        // e.preventDefault();
    }

    _onDragMouseMove = (e) => {
        //todo: anything to improve performance here?
        this.setState(prevState => ({
            dragDeltaY: e.clientY - prevState.dragStartY
        }));
    }

    _onDragMouseUp = (e) => {
        let hoveredChild = this.props.children.find((child, idx) => {
            let clientRect = this.refs[child.props.entityID].getBoundingClientRect();
            return e.clientY >= clientRect.top && e.clientY <= clientRect.bottom || idx === 0 && e.clientY < clientRect.top || idx === this.props.children.length - 1 && e.clientY > clientRect.bottom;
        });

        if (hoveredChild && hoveredChild.props.entityID !== this.state.currentlyDraggedItemID) {
            this.props.onChange(this, this.state.currentlyDraggedItemID, hoveredChild.props.sortValue);
        }

        this._onDragStop();
    }

    _onDragKeyDown = (e) => {
        if (e.target === document.body && event.key === 'Escape') {
            this._onDragStop()
        }
    }

    _onDragStop = () => {
        this.setState({
            isDragActive: false,
            dragStartY: null,
            currentlyDraggedItemID: null,
            dragDeltaY: null
        });

        this._clearEventListeners();
    }


    _clearEventListeners = () => {
        removeEvent(document, 'mouseup', this._onDragMouseUp);
        removeEvent(document, 'keydown', this._onDragKeyDown);
        removeEvent(document, 'mousemove', this._onDragMouseMove);
    }

    _renderListItem = (item) => {
        let isBeingDragged = this.state.isDragActive && item.props.entityID === this.state.currentlyDraggedItemID;

        let topOffset = '0';
        let node = this.refs[item.props.entityID];

        if (isBeingDragged) {
            topOffset = this.state.dragDeltaY;
        } else if (this.state.isDragActive && !isBeingDragged && node) {
            let itemClientRect = node.getBoundingClientRect();

            if (this.state.dragStartY > itemClientRect.bottom && this.state.dragStartY + this.state.dragDeltaY < itemClientRect.bottom) {
                topOffset = this.state.currentlyDraggedElementHeight;
            }
            if (this.state.dragStartY < itemClientRect.top && this.state.dragStartY + this.state.dragDeltaY > itemClientRect.top) {
                topOffset = -this.state.currentlyDraggedElementHeight;
            }
        }

        return (
            <div className={'draggable-wrapper ' + item.props.className}
                ref={item.props.entityID}
                style={{ zIndex: isBeingDragged ? 2 : 1 }}
                key={item.props.entityID}
            >
                <div className={'draggable' + (isBeingDragged ? ' is-dragged' : '') + (item.props.disabled ? ' disabled' : '')}
                    onMouseDown={!item.props.disabled ? this._onDragStart.bind(this, item.props.entityID) : null}
                    style={{ top: topOffset + 'px' }}
                    key={item.props.entityID}>
                    {item.props.children}
                </div>
            </div>
        );
    }

    render() {
        return <div className={'drag-and-drop-sortable-list ' + (this.props.className || '')}>
            {Array.isArray(this.props.children) ?
                this.props.children.map(this._renderListItem) :
                this.props.children}
        </div>
    }
}